import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthor } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthor';
import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfo } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfo';
import type { DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetEngagement } from './discoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetEngagement';

/**
 * 참조된 트윗 요약 정보 (순환 참조 방지)
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweet = {
  /** 트윗 작성자 정보 */
  author?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetAuthor;
  basicInfo?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfo;
  engagement?: DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetEngagement;
};
